import { TaskT } from 'ui-io/task-io/task-t'

export type NumberKey = 'configPriority' | 'discussionLength' | 'taskAge'

const numberExtractors: Record<
  NumberKey,
  (task: TaskT) => number | undefined | null
> = {
  configPriority: (task: TaskT) => task.configPriority,
  discussionLength: (task: TaskT) => task.discussionLength,
  taskAge: (task: TaskT) =>
    task.creationTime
      ? Math.floor(
          (new Date().getTime() - task.creationTime.getTime()) / (1000 * 3600),
        )
      : undefined,
}

export default numberExtractors
